import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

const DistrictSelect = ({ array, value, handleDistrictChange }) => {

  if (!array) array = [];

  const flatProps = {
    options: array,
  };

  return (
    <div>
      <div style={{ maxWidth: 300 }}>
        <Autocomplete
          {...flatProps}
          id="districts"
          value={value}
          onChange={e => handleDistrictChange(e)}
          renderInput={params => <TextField {...params} placeholder="Назва району" margin="normal" fullWidth />}
        />
      </div>
    </div>
  );
};

export default DistrictSelect;
